<template>
  <a-layout :class="['layout', device]">

    <a-layout :class="[layoutMode, `content-width-${contentWidth}`]" :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }">
      <!-- layout header -->
      <back-header
        :mode="layoutMode"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />

      <!-- layout content -->
      <a-layout-content :style="{ height: '100%', margin: '24px 24px 0', paddingTop: fixHeader ? '64px' : '0' }">
        <!-- 多标签tabs -->
        <router-view v-slot="{ Component }">
          <!-- <keep-alive> -->
            <component :is="Component"/>
          <!-- </keep-alive> -->
        </router-view>
        <!-- <transition name="page-transition">
          <keep-alive>
            <router-view />
          </keep-alive>
        </transition> -->
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer>
        <global-footer />
      </a-layout-footer>

    </a-layout>
  </a-layout>
</template>

<script>
import { mapActions } from 'vuex';

// layouts/library 组件
import BackHeader from '@/library/GlobalHeader/BackHeader';
import GlobalFooter from '@/library/GlobalFooter';

export default {
  name: 'BackLayout',
  components: {
    BackHeader,
    GlobalFooter,
  },
  data () {
    return {
      collapsed: false,
    };
  },
  computed: {
    contentPaddingLeft () {
      if (!this.fixSidebar || this.isMobile()) {
        return '0';
      }
      if (this.sidebarOpened) {
        return '256px';
      }
      return '80px';
    },
  },
  watch: {
    sidebarOpened (val) {
      this.collapsed = !val;
    },
  },
  created () {
    this.collapsed = !this.sidebarOpened;
  },
  mounted () {
    const userAgent = navigator.userAgent;
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed;
        setTimeout(() => {
          this.collapsed = !this.collapsed;
        }, 16);
      });
    }
  },
  methods: {
    ...mapActions(['setSidebar']),
    toggle () {
      this.collapsed = !this.collapsed;
      this.setSidebar(!this.collapsed);
    },
    drawerClose () {
      this.collapsed = false;
    }
  }
};
</script>

<style lang="less">

/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
